@if (pageReady) {
  <main class="gs-page">
    <div class="contact-info-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="gs-content-container">
        <div class="notification-container">
          <app-notification></app-notification>
        </div>
        <div class="top-content-container">
          <div class="all-contactmethod-container">
            @if (emailList.length !== 0) {
              <div class="contact-method-container">
                <div class="list-header">
                  <h3>{{ pageLabels.emailHeaderText }}</h3>
                </div>
                <form [formGroup]="contactForm">
                  <mat-accordion class="contactmethod-list" multi formArrayName="EmailForms">
                    @for (email of emailList; let i = $index; track email) {
                      <mat-expansion-panel #panel>
                        <mat-expansion-panel-header class="contactmethod-header">
                          <div class="panel-header-container">
                            <div class="method-img"><i class="fa-thin fa-envelope"></i></div>
                            <div class="method-details">
                              <p class="method-header">
                                {{ email.Email }}
                              </p>
                            </div>
                            @if (email.IsPrimary) {
                              <p class="primary-alert">{{ pageLabels.primaryEmailText }}</p>
                            }
                            @if (email.Type !== "EMAIL") {
                              <p class="undeliverable-alert">
                                <i class="fa-regular fa-circle-exclamation"></i> {{ pageLabels.undeliverableEmailText }}
                              </p>
                            }
                          </div>
                        </mat-expansion-panel-header>
                        <div>
                          <form class="contactmethod-form email-form" [formGroupName]="i">
                            <div class="bot-row">
                              <mat-form-field
                                class="nickname"
                                appearance="outline"
                                color="primary"
                                subscriptSizing="dynamic"
                              >
                                <mat-label>{{ pageLabels.emailAddressInputLabel }}</mat-label>
                                <input
                                  formControlName="ExistingEmail"
                                  type="text"
                                  maxlength="45"
                                  matInput
                                  value="{{ email.Email }}"
                                  aria-labelledby="updateUndeliverableHint emailRequiredError emailFormatError"
                                />
                                @if (existingEmailsForm.at(i).get("ExistingEmail")?.hasError("email")) {
                                  <mat-error id="emailFormatError">{{
                                    emailInlineErrors.emailValidFormatText
                                  }}</mat-error>
                                }
                                @if (existingEmailsForm.at(i).get("ExistingEmail")?.hasError("required")) {
                                  <mat-error id="emailRequiredError">{{
                                    emailInlineErrors.emailRequiredText
                                  }}</mat-error>
                                }
                                @if (existingEmailsForm.at(i).get("Deliverable")?.hasError("undeliverable")) {
                                  <mat-hint id="updateUndeliverableHint" class="hint-error-text">{{
                                    showUpdateUndeliverableMessage
                                      ? pageLabels.pleaseUpdateOnFileText
                                      : pageLabels.pleaseUpdateText
                                  }}</mat-hint>
                                }
                              </mat-form-field>
                              @if (emailList.length !== 1) {
                                <mat-checkbox
                                  class="default-cb"
                                  [disabled]="emailList.length === 1"
                                  [disableRipple]="emailList.length === 1"
                                  (click)="disablePrimaryCheckbox($event, i)"
                                  formControlName="SetPrimary"
                                  color="primary"
                                  >{{ pageLabels.primaryCbLabelText }}</mat-checkbox
                                >
                              }
                            </div>
                            <div class="contactmethod-form-btn-container">
                              <button
                                id="Update-{{ i }}"
                                class="gs-form-button-primary contact-button-width"
                                mat-flat-button
                                color="primary"
                                (click)="updateEmail(email, i)"
                                [attr.aria-label]="getBtnAriaLabels(email.Email, 'update')"
                              >
                                {{ pageLabels.updateButtonText }}
                              </button>
                              <button
                                id="Cancel-{{ i }}"
                                class="gs-form-button-primary contact-button-width cancel-button"
                                mat-flat-button
                                color="primary"
                                (click)="cancelChanges(email, i)"
                                [attr.aria-label]="getBtnAriaLabels(email.Email, 'cancel')"
                              >
                                {{ pageLabels.cancelButtonText }}
                              </button>
                              @if (emailList.length > 1 && !email.IsPrimary) {
                                <button
                                  id="Remove-{{ i }}"
                                  class="gs-button-link remove-button"
                                  (click)="removeEmail(email)"
                                  [attr.aria-label]="getBtnAriaLabels(email.Email, 'remove')"
                                >
                                  {{ pageLabels.removeButtonText }}
                                </button>
                              }
                            </div>
                          </form>
                        </div>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </form>
              </div>
            } @else {
              <div class="new-contact-method-container">
                <mat-accordion class="contactmethod-list" multi>
                  <mat-expansion-panel #panel>
                    <mat-expansion-panel-header class="contactmethod-header">
                      <div class="panel-header-container">
                        <div class="method-img"><i class="fa-thin fa-circle-plus" style="color: #b4b4b4"></i></div>
                        <div class="method-details">
                          <p class="method-header">
                            {{ pageLabels.addNewEmailHeader }}
                          </p>
                        </div>
                      </div>
                    </mat-expansion-panel-header>
                    <div>
                      <form class="contactmethod-form email-form" [formGroup]="newEmailForm">
                        <div class="bot-row new-email-row">
                          <mat-form-field
                            class="new-email-input"
                            appearance="outline"
                            color="primary"
                            id="newEmail"
                            subscriptSizing="dynamic"
                          >
                            <mat-label>{{ pageLabels.emailAddressInputLabel }}</mat-label>
                            <input
                              formControlName="newEmail"
                              type="text"
                              maxlength="45"
                              matInput
                              value=""
                              aria-labelledby="newEmailFormatError newEmailRequiredError"
                            />
                            @if (newEmailForm.get("newEmail")?.hasError("email")) {
                              <mat-error id="newEmailFormatError">{{
                                emailInlineErrors.emailValidFormatText
                              }}</mat-error>
                            }
                            @if (newEmailForm.get("newEmail")?.hasError("required")) {
                              <mat-error id="newEmailRequiredError">{{
                                emailInlineErrors.emailRequiredText
                              }}</mat-error>
                            }
                          </mat-form-field>
                          <mat-form-field
                            class="new-email-input"
                            appearance="outline"
                            color="primary"
                            id="newEmailConfirm"
                            subscriptSizing="dynamic"
                          >
                            <mat-label>{{ pageLabels.confirmEmailInputLabel }}</mat-label>
                            <input
                              formControlName="newEmailConfirm"
                              type="text"
                              maxlength="45"
                              matInput
                              value=""
                              aria-labelledby="confirmNewEmailFormatError confirmNewEmailRequiredError confirmNewEmailMisMatchError"
                              (blur)="checkEmailsMatch()"
                            />
                            @if (newEmailForm.get("newEmailConfirm")?.hasError("email")) {
                              <mat-error id="confirmNewEmailFormatError">{{
                                emailInlineErrors.emailValidFormatText
                              }}</mat-error>
                            }
                            @if (newEmailForm.get("newEmailConfirm")?.hasError("required")) {
                              <mat-error id="confirmNewEmailRequiredError">{{
                                emailInlineErrors.emailRequiredText
                              }}</mat-error>
                            }
                            @if (newEmailForm.get("newEmailConfirm")?.hasError("doNotMatch")) {
                              <mat-error id="confirmNewEmailMisMatchError">{{
                                emailInlineErrors.emailValidMatchText
                              }}</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="contactmethod-form-btn-container">
                          <button
                            id="AddNewEmailBtn"
                            class="gs-form-button-primary contact-button-width"
                            mat-flat-button
                            color="primary"
                            (click)="addEmail()"
                            [attr.aria-label]="pageLabels.addNewEmailAriaLabel"
                          >
                            {{ pageLabels.addButtonText }}
                          </button>
                          <button
                            id="CancelNewEmailBtn"
                            class="gs-form-button-primary contact-button-width cancel-button"
                            mat-flat-button
                            color="primary"
                            (click)="cancelNewEmail()"
                            [attr.aria-label]="pageLabels.cancelNewEmailAriaLabel"
                          >
                            {{ pageLabels.cancelButtonText }}
                          </button>
                        </div>
                      </form>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            }
            <div class="contact-method-container">
              <div class="list-header">
                <h3>{{ pageLabels.phoneHeaderText }}</h3>
              </div>
              <form [formGroup]="phoneContactForm">
                <mat-accordion class="contactmethod-list" multi formArrayName="PhoneForms">
                  @for (phone of phoneList; let i = $index; track phone) {
                    <mat-expansion-panel #panel>
                      <mat-expansion-panel-header class="contactmethod-header">
                        <div class="panel-header-container">
                          <div class="method-img"><i class="fa-thin fa-phone"></i></div>
                          <div class="method-details">
                            <p class="method-header">
                              {{ phone.Number }}
                            </p>
                          </div>
                          @if (phone.IsPrimary) {
                            <p class="primary-alert">Primary</p>
                          }
                          @if (phone.Type === 2) {
                            <p class="undeliverable-alert">
                              <i class="fa-regular fa-circle-exclamation"></i> {{ pageLabels.unconfirmedPhoneText }}
                            </p>
                          }
                        </div>
                      </mat-expansion-panel-header>
                      <div>
                        <form class="contactmethod-form email-form" [formGroupName]="i">
                          <div class="bot-row phone-bot-row">
                            <mat-form-field
                              class="phone-input-field"
                              appearance="outline"
                              color="primary"
                              subscriptSizing="dynamic"
                            >
                              <mat-label>{{ pageLabels.phoneNumberLabelText }}</mat-label>
                              <input
                                formControlName="ExistingPhone"
                                type="text"
                                maxlength="14"
                                matInput
                                value="{{ phone.Number }}"
                                (input)="formatPhoneInput($event)"
                                aria-labelledby="notUniquPhoneError phoneRequiredError"
                              />
                              @if (existingPhonesForm.at(i).get("ExistingPhone")?.hasError("notUnique")) {
                                <mat-error id="notUniquPhoneError">{{ pageLabels.phoneUniqueErrorText }}</mat-error>
                              }
                              @if (existingPhonesForm.at(i).get("ExistingPhone")?.hasError("required")) {
                                <mat-error id="phoneRequiredError">{{
                                  pageLabels.phoneNumberRequiredErrorText
                                }}</mat-error>
                              }
                            </mat-form-field>
                            <mat-form-field class="payment-list phone-input-field" appearance="outline" color="primary">
                              <mat-label>{{ pageLabels.phoneTypeLabelText }}</mat-label>
                              <mat-select formControlName="PhoneType" aria-labelledby="phoneTypeRequiredError">
                                <mat-option class="new-paymethod-option" [value]="0">
                                  {{ pageLabels.mobileOptionLabelText }}
                                </mat-option>
                                <mat-option class="new-paymethod-option" [value]="1">
                                  {{ pageLabels.landlineOptionLabelText }}
                                </mat-option>
                              </mat-select>
                              @if (existingPhonesForm.at(i).get("PhoneType")?.hasError("required")) {
                                <mat-error id="phoneTypeRequiredError">{{
                                  pageLabels.phoneTypeRequiredErrorText
                                }}</mat-error>
                              }
                            </mat-form-field>
                            <mat-checkbox
                              class="default-cb phone-input-field"
                              formControlName="SetPrimary"
                              color="primary"
                              >{{ pageLabels.primaryCbLabelText }}
                            </mat-checkbox>
                          </div>
                          <div class="contactmethod-form-btn-container">
                            <button
                              id="Update-{{ i }}"
                              class="gs-form-button-primary contact-button-width"
                              mat-flat-button
                              color="primary"
                              (click)="updatePhone(phone, i)"
                              [attr.aria-label]="getBtnAriaLabels(phone.Number, 'update')"
                            >
                              {{ pageLabels.updateButtonText }}
                            </button>
                            <button
                              id="Cancel-{{ i }}"
                              class="gs-form-button-primary contact-button-width cancel-button"
                              mat-flat-button
                              color="primary"
                              (click)="cancelPhoneChanges(phone, i)"
                              [attr.aria-label]="getBtnAriaLabels(phone.Number, 'cancel')"
                            >
                              {{ pageLabels.cancelButtonText }}
                            </button>
                            @if (phoneList.length > 1 && !phone.IsPrimary) {
                              <button
                                id="Remove-{{ i }}"
                                class="gs-button-link remove-button"
                                (click)="removePhone(phone)"
                                [attr.aria-label]="getBtnAriaLabels(phone.Number, 'remove')"
                              >
                                {{ pageLabels.removeButtonText }}
                              </button>
                            }
                          </div>
                        </form>
                      </div>
                    </mat-expansion-panel>
                  }
                </mat-accordion>
              </form>
            </div>
            <div class="new-contact-method-container">
              <mat-accordion class="contactmethod-list" multi>
                <mat-expansion-panel #panel>
                  <mat-expansion-panel-header class="contactmethod-header">
                    <div class="panel-header-container">
                      <div class="method-img"><i class="fa-thin fa-circle-plus" style="color: #b4b4b4"></i></div>
                      <div class="method-details">
                        <p class="method-header">
                          {{ pageLabels.addNewPhoneHeaderText }}
                        </p>
                      </div>
                    </div>
                  </mat-expansion-panel-header>
                  <div>
                    <form class="contactmethod-form email-form" [formGroup]="newPhoneForm" #formDirective="ngForm">
                      <div class="bot-row phone-bot-row">
                        <mat-form-field
                          class="phone-input-field"
                          appearance="outline"
                          color="primary"
                          subscriptSizing="dynamic"
                        >
                          <mat-label>{{ pageLabels.phoneNumberLabelText }}</mat-label>
                          <input
                            formControlName="newNumber"
                            type="text"
                            maxlength="14"
                            matInput
                            (input)="formatPhoneInput($event)"
                            aria-labelledby="notUniquNewPhoneError newPhoneRequiredError"
                          />
                          @if (newPhoneForm.get("newNumber")?.hasError("notUnique")) {
                            <mat-error id="notUniquNewPhoneError">{{ pageLabels.phoneUniqueErrorText }}</mat-error>
                          }
                          @if (newPhoneForm.get("newNumber")?.hasError("required")) {
                            <mat-error id="newPhoneRequiredError">{{
                              pageLabels.phoneNumberRequiredErrorText
                            }}</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="payment-list phone-input-field" appearance="outline" color="primary">
                          <mat-label>{{ pageLabels.phoneTypeLabelText }}</mat-label>
                          <mat-select formControlName="newType" aria-labelledby="phoneRequiredError">
                            <mat-option class="new-paymethod-option" [value]="0">
                              {{ pageLabels.mobileOptionLabelText }}
                            </mat-option>
                            <mat-option class="new-paymethod-option" [value]="1">
                              {{ pageLabels.landlineOptionLabelText }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-checkbox class="default-cb phone-input-field" formControlName="newPrimary" color="primary"
                          >{{ pageLabels.primaryCbLabelText }}
                        </mat-checkbox>
                      </div>
                      <div class="contactmethod-form-btn-container">
                        <button
                          id="AddNewPhoneBtn"
                          class="gs-form-button-primary contact-button-width"
                          mat-flat-button
                          color="primary"
                          (click)="addPhone(formDirective)"
                          [attr.aria-label]="pageLabels.addNewPhoneAriaLabel"
                        >
                          {{ pageLabels.addButtonText }}
                        </button>
                        <button
                          id="CancelNewPhoneBtn"
                          class="gs-form-button-primary contact-button-width cancel-button"
                          mat-flat-button
                          color="primary"
                          (click)="cancelNewPhone(formDirective)"
                        >
                          {{ pageLabels.cancelButtonText }}
                        </button>
                      </div>
                    </form>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
          <app-side-panel [panelData]="sidePanelData"></app-side-panel>
        </div>
        <div class="page-link-container">
          <mat-divider class="divider"></mat-divider>
          <button
            (click)="goToManageAccount()"
            role="link"
            class="gs-form-button-primary"
            mat-flat-button
            color="primary"
          >
            {{ pageLabels.manageAccountButtonText }}
          </button>
        </div>
      </div>
    </div>
  </main>
}
